import { ExtendableError } from '../../errors/ExtendableError';

export class RouteMissing extends ExtendableError {}
